import { render, staticRenderFns } from "./CompanyViews.vue?vue&type=template&id=07d2ffb5"
import script from "./CompanyViews.vue?vue&type=script&lang=js"
export * from "./CompanyViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports